
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalogOpen as ObiTwowayAnalogOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-open.js';
 
 
 

 
 export const ObiTwowayAnalogOpen = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-open',
   elementClass: ObiTwowayAnalogOpenElement,
   events: {
     
   }
  });
 
 